import * as React from 'react';
import styled from 'styled-components';
import { Logo } from '../../atoms/Logo/Logo';
import { media } from '../../../utilities/media';
import { gridWidth, GRID_UNIT } from '../../../utilities/grid';
const StyledHeader = styled.header `
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: ${props => props.theme.palette.midnight.main};
  height: 64px;
  padding: 0 ${GRID_UNIT * 2}px;
  ${media.tablet `
    height: 76px;
  `};
`;
const LogoContainer = styled.div `
  margin: 0 16px 0 0;
  width: 34px;
  ${media.tablet `
    width: 200px;
  `};
`;
const HeaderContainer = styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  ${media.tablet `
      margin 0 auto;
      max-width: ${gridWidth['tablet'](12)}px;
    `};
`;
const HeaderItems = styled.div `
  height: 24px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-grow: 1;
  & > * {
    margin-right: 10px;
  }

  & > *:last-child {
    margin-right: 0;
  }
`;
export class Header extends React.PureComponent {
    render() {
        const { logoHref, logoContent } = this.props;
        return (React.createElement(StyledHeader, null,
            React.createElement(HeaderContainer, null,
                React.createElement(LogoContainer, null, logoContent ? logoContent : React.createElement(Logo, { href: logoHref })),
                React.createElement(HeaderItems, null, this.props.children))));
    }
}
Header.defaultProps = {
    logoHref: '/',
};
//# sourceMappingURL=Header.js.map